@if (UserRule.projectEditing | hasRule) {
  @let projectResults = projects$ | async;
  @if (projectResults?.totalHits) {
    <div class="search-group">
      <div
        class="search-group-header"
        [routerLink]="'/projects'"
        [queryParams]="{ search: searchValue }"
      >
        <mat-icon>folder</mat-icon>
        <h6>
          {{ "project.projects" | translate }}
        </h6>
        <div class="search-group-header-total">
          {{ projectResults?.totalHits }}
        </div>
      </div>
      @for (project of projectResults?.projects; track project.id) {
        <div class="search-item" (click)="onOpenProject(project)">
          {{ project.name }}
        </div>
      }
    </div>
  }
}

@let collectionResults = collections$ | async;
@if (collectionResults?.totalHits) {
  <div class="search-group">
    <div
      class="search-group-header"
      [routerLink]="'/collections'"
      [queryParams]="{ search: searchValue }"
    >
      <mat-icon>team_dashboard</mat-icon>
      <h6>
        {{ "collection.collections" | translate }}
      </h6>
      <div class="search-group-header-total">
        {{ collectionResults?.totalHits }}
      </div>
    </div>
    @for (collection of collectionResults?.collections; track collection.id) {
      <div class="search-item" (click)="onOpenCollection(collection)">
        {{ collection.name }}
      </div>
    }
  </div>
}

@if (UserRule.projectEditing | hasRule) {
  @let modelResults = models$ | async;
  @if (modelResults?.totalHits) {
    <div class="search-group">
      <div
        class="search-group-header"
        [routerLink]="'/models'"
        [queryParams]="{ query: searchValue }"
      >
        <mat-icon>person</mat-icon>
        <h6>
          {{ "model.models" | translate }}
        </h6>
        <div class="search-group-header-total">
          {{ modelResults?.totalHits }}
        </div>
      </div>
      @for (model of modelResults?.models; track model.id) {
        <div class="search-item" (click)="onOpenModel(model)">
          {{ model | modelName }}
        </div>
      }
    </div>
  }
}

@let assetResults = assets$ | async;
@if (assetResults?.totalHits) {
  <div class="search-group">
    <div
      class="search-group-header"
      [routerLink]="'/assets'"
      [queryParams]="{ search: searchValue }"
    >
      <mat-icon>image</mat-icon>
      <h6>
        {{ "asset.assets" | translate }}
      </h6>
      <div class="search-group-header-total">
        {{ assetResults?.totalHits }}
      </div>
    </div>
    @for (asset of assetResults?.assets; track asset.id) {
      <div class="search-item" (click)="onOpenAsset(asset)">
        {{ asset.name }}
      </div>
    }
  </div>
}

@if (
  (!(UserRule.projectEditing | hasRule) ||
    (!(projects$ | async)?.totalHits && !(models$ | async)?.totalHits)) &&
  !(assets$ | async)?.totalHits
) {
  <p class="no-results">
    {{ "search.no-results" | translate }}
  </p>
}
